import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import {
  ParamsModel,
  ProductSearchPage,
  SuggestionResponse,
} from '@boels/models';
import { ApiContextService } from '@boels/shared-state';
import { HttpService } from '@boels/helpers';

@Injectable()
export class CustomSearchBoxService {
  private httpService = inject(HttpService);
  private apiContextService = inject(ApiContextService);

  private searchValue = '';

  getSuggestions(term: string): Observable<SuggestionResponse> {
    return this.apiContextService.getContext().pipe(
      switchMap(([baseSite, language, currency]) => {
        const queryParams: ParamsModel = [
          ['term', term],
          ['max', 5],
          ['lang', language],
          ['curr', currency],
        ];
        return this.httpService.get<SuggestionResponse>(
          `${baseSite.uid}/products/suggestions`,
          queryParams,
        );
      }),
    );
  }

  getProducts(
    term: string,
    pageSize: number,
    currentPage = 0,
    sort = 'relevance',
  ): Observable<ProductSearchPage> {
    return this.apiContextService.getContext().pipe(
      switchMap(([baseSite, language, currency]) => {
        const queryParams: ParamsModel = [
          ['fields', 'FULL'],
          ['pageSize', pageSize],
          ['currentPage', currentPage],
          ['query', term],
          ['lang', language],
          ['curr', currency],
          ['sort', sort],
        ];
        return this.httpService.get<ProductSearchPage>(
          `${baseSite.uid}/products/search`,
          queryParams,
        );
      }),
    );
  }

  getSearchValue(): string {
    return this.searchValue;
  }

  setSearchValue(searchValue: string): void {
    this.searchValue = searchValue;
  }
}
